import firebaseClientDefaults from "./firebaseClientDefaults.json";

export const FIREBASE_APP_CHECK_SITE_KEY_ENV =
  "REACT_APP_FIREBASE_APP_CHECK_RECAPTCHA_ENTERPRISE_SITE_KEY";

const RECAPTCHA_ENTERPRISE_SITE_KEY_PATTERN = /^[A-Za-z0-9_-]{20,100}$/;

function enabled(value) {
  return String(value || "").trim().toLowerCase() === "true";
}

function isProduction(env) {
  return String(env.NODE_ENV || "").trim().toLowerCase() === "production";
}

export function isValidRecaptchaEnterpriseSiteKey(value) {
  const siteKey = String(value || "").trim();
  const normalised = siteKey.toLowerCase();
  return (
    RECAPTCHA_ENTERPRISE_SITE_KEY_PATTERN.test(siteKey) &&
    !normalised.includes("your_") &&
    !normalised.includes("placeholder") &&
    !normalised.includes("xxxx")
  );
}

export function getFirebaseAppCheckConfig(
  env = process.env,
  firebaseConfig = {},
  emulatorConfig = null,
) {
  // App Check is intentionally production-only. Local previews, Jest and the
  // Firebase Emulator Suite must not make real reCAPTCHA Enterprise requests.
  if (
    !isProduction(env) ||
    emulatorConfig ||
    enabled(env.REACT_APP_USE_FIREBASE_EMULATORS)
  ) {
    return null;
  }

  const siteKey = String(env[FIREBASE_APP_CHECK_SITE_KEY_ENV] || "").trim();
  if (!siteKey) return null;

  if (String(firebaseConfig.projectId || "") !== firebaseClientDefaults.projectId) {
    throw new Error(
      "Firebase App Check may only initialise for the configured Urban Unity Network production project.",
    );
  }
  if (!isValidRecaptchaEnterpriseSiteKey(siteKey)) {
    throw new Error(
      `${FIREBASE_APP_CHECK_SITE_KEY_ENV} must be a valid reCAPTCHA Enterprise site key.`,
    );
  }

  return {
    siteKey,
    isTokenAutoRefreshEnabled: true,
  };
}
